'use strict';
const angular = require('angular');

/*@ngInject*/
export function ReservableEventService($resource) {
  return $resource('/api/reservable-events/:id', {
    id: '@_id'
  },{
    getByType: {
      method: 'GET',
      url: "/api/reservable-events/type/:type",
      isArray: true
    },
    getCalendarByType: {
      method: 'GET',
      url: "/api/reservable-events/calendar/:type",
      isArray: true
    },
    getUpcoming: {
      method: 'GET',
      url: "/api/reservable-events/upcoming/:count",
      isArray: true
    },
    patch: {
      method: 'PATCH'
    },
    update: {
      method: 'PUT'
    }
  });
}


export default angular.module('conduuApp.ReservableEventService', [])
  .factory('ReservableEventService', ReservableEventService)
  .name;



// WEBPACK FOOTER //
// ./client/services/reservable-event/event.service.js